"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noticeInfo = noticeInfo;
exports.noticeList = noticeList;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function noticeInfo(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/public/system/notice/info',
    method: 'GET',
    params: data
  });
}
function noticeList(params) {
  return (0, _request.default)({
    url: '/admin/public/system/notice/list',
    method: 'GET',
    params: params
  });
}